<template>
	<div class="view filter-view">
		<HeaderBar :titleParam="tag_title" />
		<div class="news-list"
			 v-infinite-scroll="loadMore"
			 :infinite-scroll-disabled="bottomLoading">
			<NewsItem v-for="item in newsItemList"
					  :key="item.id"
					  v-bind="item" />

			<div class="no-content"
			 v-show="isNoContent">———— 暂无内容 ————</div>
		</div>
		
	</div>
</template>
<script>
import NewsItem from '../../components/NewsItem'
import HeaderBar from '../../components/HeaderBar'
import apiUtil from '../../utils/apiUtil'
import apiConst from '../../consts/apiConst'
export default {
	name: 'filtered',
	components: { HeaderBar, NewsItem },

	data() {
		return {
			tag_id: 0,
			tag_title: '',
			bottomLoading: false,
			page: 1,
			loadFinished: false,
			newsItemList: [],
			isNoContent: false,
			firstLoaded: false
		}
	},
	created() {
		const { tag_id } = this.$route.query
		this.tag_id = tag_id
		this.init(tag_id, 1)
	},
	methods: {
		async init(tag_id, page) {
			const res = await apiUtil.post(apiConst.getTagNews, {
				tag_id,
				page,
				pagesize: 10
			})
			if (res.success) {
				this.firstLoaded = true;
				const { list, tag_title } = res;
				this.newsItemList = this.newsItemList.concat(list)
				this.tag_title = tag_title;
				this.page = page;
				if (list.length === 0) {
					this.isNoContent = true;
					return;
				}
				if (list.length < 10) {
					this.loadFinished = true;
				}
			}
		},
		loadMore() {
			if (!this.loadFinished && this.firstLoaded) {
				this.init(this.tag_id, this.page + 1)
			}
		}
	}
}
</script>
<style lang="stylus" scoped>
.filter-view {
	height: 100%;

	.news-list {
		height: 100%;
		padding: 0 15px;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch
		.no-content {
			height: 90px;
			line-height: 90px;
			color: #999;
			text-align: center;
		}
	}
}
</style>

